import Api  from './Api'
import axios from 'axios'
import fileDownload from 'js-file-download';
import translateFilters from '../utils/translateFilters'

class ReportsApi extends Api {
    async excel(filters = {}){
        const request = async () => await axios.get(
            this.generateAbsolutePath('aceptados/reporte/excel'), { 
                params: translateFilters(filters),
                responseType: 'blob'
            }
        );
            
        return await this.perform(request)
            .then((response) => this.handleDownload('Inscripciones.xlsx', response));
    }

    async concentrated(filters = {}){
        const request = async () => await axios.get(
            this.generateAbsolutePath('aceptados/reporte/concentrado'), { 
                params: translateFilters(filters),
                responseType: 'blob'
            }
        );
            
        return await this.perform(request)
            .then((response) => this.handleDownload('Concentrado.xlsx', response));
    }

    async pendingDocumentation(filters = {}){
        const request = async () => await axios.get(
            this.generateAbsolutePath('aceptados/reporte/alumnos-sin-documentacion'), { 
                params: translateFilters(filters),
                responseType: 'blob'
            }
        );
            
        return await this.perform(request)
            .then((response) => this.handleDownload('AlumnosSinDocumentacion.xlsx', response));
    }

    async studentPhotos(){
        const request = async () => await axios.get(
            this.generateAbsolutePath('inscripcion/fotografias'), { responseType: 'blob' }
        );
            
        return await this.perform(request)
            .then((response) => this.handleDownload('FotografiasAlumnos.zip', response));
    }

    /**
     * Download the blob file from the API response.
     * 
     * @param {String} defaultFileName Fallback filename, in case it's not specified in the response headers.
     * @param {Object} response Axios response object.
     */
    handleDownload(defaultFileName, response){
        const { data, headers } = response;

        let fileName = headers['content-disposition'];
        fileName = fileName === undefined ? defaultFileName : fileName.split('filename=')[1];

        fileDownload(data, fileName)
    }
}

export default ReportsApi;